<!--
 * @Description:
 * @Author: mdb
 * @Date: 2022-09-15 14:31:03
 * @LastEditTime: 2023-04-19 18:47:28
 * @LastEditors: mdb
-->
<template>
  <a-form ref="formRef" :model="dataForm" :rules="formRules" autocomplete="off" scrollToFirstError>
    <dc-layout-card :title="props.title" :span="6">
      <dc-form-item label="标签名称" name="name">
        <CosInput
          v-model:value="dataForm.name"
          :maxlength="100"
          placeholder="请输入标签名称"
          :disabled="props.type === 'view'"
          :view="props.type === 'view'"
        />
      </dc-form-item>
      <dc-form-item label="上级标签" name="parentId">
        <CosSelect
          :fieldNames="{ label: 'name', value: 'id' }"
          v-model:value="dataForm.parentId"
          placeholder="请选择上级标签"
          allowClear
          :disabled="props.type === 'view'"
          :view="props.type === 'view'"
          :options="parentLabelEnum"
        />
      </dc-form-item>
      <dc-form-item label="标签类型" name="type">
        <CosSelect
          v-model:value="dataForm.type"
          :options="typeEnum"
          placeholder="请选择标签类型"
          :disabled="props.type === 'view'"
          :view="props.type === 'view'"
        />
      </dc-form-item>
      <a-col :span="24" />
      <dc-form-item label="备注" name="remark" :span="12">
        <CosTextarea
          v-model:value="dataForm.remark"
          :maxlength="2000"
          :disabled="props.type === 'view'"
          :view="props.type === 'view'"
        />
      </dc-form-item>
    </dc-layout-card>
  </a-form>

  <cos-footer-button
    v-model:value="dataForm"
    :formRef="formRef"
    :resetValue="initForm"
    :loading="loading"
    :disabled="props.type === 'view'"
    :permissionPage="permissionPage"
    :editUrl="`/${props.subdomain}/tagsManage/edit?id=${queryId}`"
    @submit="onSubmit"
  />
</template>

<script setup lang="ts">
import { ref, reactive, toRaw, computed, onBeforeMount } from 'vue'
import { useRoute } from 'vue-router'
import { cloneDeep } from 'lodash-es'
import { goBack } from '@/hooks/cosRouter'
import { message } from '@dc-platform/dc-components'
import { DropListType } from '@/typings/common'
import { selectForNumberValidate } from '@/utils/validate'
import { MarketingManageEditParams } from '@/typings/api/marketingManage'
import { parentLabelList, tagsManageAdd, tagsManageEdit, tagsManageDetails } from '@/api/marketing/marketingManage'
import type { SelectProps, FormInstance } from 'ant-design-vue'
const route = useRoute()

const props = defineProps<{
  value?: MarketingManageEditParams
  type: 'add' | 'edit' | 'view'
  subdomain: 'fbu' | 'lbu'
  title: string
}>()

const typeEnum = ref<SelectProps['options']>([{ value: 1, label: '静态标签' }])
const permissionPage = computed(() => {
  const addPermissions = {
    fbu: { save: 'fbu_tags_add_btn' },
    lbu: { save: 'lbu_tags_add_btn' }
  }
  const otherPermissions = {
    fbu: { edit: 'fbu_tags_edit_btn', save: 'fbu_tags_edit_btn' },
    lbu: { edit: 'lbu_tags_edit_btn', save: 'lbu_tags_edit_btn' }
  }
  return props.type === 'add' ? addPermissions[props.subdomain] : otherPermissions[props.subdomain]
})

const initForm = reactive<MarketingManageEditParams>({
  name: undefined,
  parentId: undefined,
  type: 1,
  remark: undefined
})
const formRef = ref<FormInstance>()
const dataForm = reactive<MarketingManageEditParams>(cloneDeep(initForm))
const formRules = reactive({
  name: [{ required: true, message: '请输入标签名称' }],
  type: [{ required: true, validator: selectForNumberValidate, message: '请选择标签类型' }]
})

const queryId = computed(() => route.query.id as string)
const parentLabelEnum = ref<DropListType>([])
const getParentLabel = () => {
  const params: { id?: number } = {}
  if (queryId.value) params.id = parseInt(queryId.value)
  parentLabelList(params).then((res) => {
    parentLabelEnum.value = res.data
  })
}
const loading = ref(false)
const getTagsDetails = () => {
  loading.value = true
  tagsManageDetails({ id: queryId.value })
    .then((res) => {
      Object.assign(dataForm, res.data)
      Object.assign(initForm, res.data)
    })
    .finally(() => {
      loading.value = false
    })
}
onBeforeMount(() => {
  getParentLabel()
  if (props.type !== 'add') {
    getTagsDetails()
  }
})

const submitTagsAdd = () => {
  loading.value = true
  tagsManageAdd(toRaw(dataForm))
    .then(() => {
      message.success('新增标签成功')
      goBack()
    })
    .finally(() => {
      loading.value = false
    })
}
const submitTagsEdit = () => {
  loading.value = true
  tagsManageEdit(toRaw(dataForm))
    .then(() => {
      message.success('修改标签成功')
      goBack()
    })
    .finally(() => {
      loading.value = false
    })
}

const onSubmit = () => {
  if (props.type === 'add') {
    submitTagsAdd()
  } else if (props.type === 'edit') {
    submitTagsEdit()
  }
}
</script>
<script lang="ts">
export default { name: 'DetailForm' }
</script>

<style scoped></style>
